import React from "react";
import { Helmet } from "react-helmet";
import SingleCardData from "./singleCardData";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/sidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";


const SingleCard = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Single card - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <SingleCardData />
                </div>
            </div>
        </div>
        
    );
}

export default SingleCard;
